import type { ApiResource } from "api/resources/resource";

import { ApiClient } from "../baseClient";

/**
 * @deprecated in favor of Zodios
 * @see src/api/client.ts
 */
export abstract class AdminBaseClient<T extends ApiResource, Paginated extends boolean = true> extends ApiClient<
  T,
  Paginated
> {
  abstract readonly adminEndpoint: () => string;
  endpoint = () => `/admin${this.adminEndpoint()}`;
}
